import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials sends the httpOnly `access_token` cookie automatically.
export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

/**
 * Build a URL for a photo stored under `filename`.
 *
 * Iter 92 — cache-bust support. When `version` is provided, we append
 * `?v=<version>` so a fresh upload / edit is picked up immediately, even
 * when the browser (or upstream CDN) has cached the previous bytes under
 * the bare URL. Callers should pass the member's `updated_at` (or any
 * value that changes when the photo is replaced) — that's a stable key
 * per profile state, so the browser can still cache within a single edit
 * cycle but is forced to revalidate when the profile updates.
 *
 * A boolean `true` triggers a fresh `Date.now()` stamp — useful in the
 * upload success handler when the parent hasn't received the new
 * `updated_at` yet.
 *
 * Iter 95 — `formToken` (optional) is threaded into the URL when set so
 * public-form callers can preview their own photo without being logged
 * in. Backend enforces that the form_token maps to the year_role that
 * owns the requested filename; other filenames → 403.
 */
export const uploadUrl = (filename, version, formToken) => {
    if (!filename) return "";
    const base = `${API_BASE}/uploads/${encodeURIComponent(filename)}`;
    const params = new URLSearchParams();
    if (version === true) params.set("v", String(Date.now()));
    else if (version !== undefined && version !== null && version !== "") params.set("v", String(version));
    if (formToken) params.set("form_token", String(formToken));
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
};
